<template>
  <Link
    v-if="(tag === 'a' || tag === 'Internal Link') && link"
    class="btn"
    :href="link"
    :class="classes"
    preserve-state>
    <slot>Button Text</slot>
    <span
      v-if="
        style.toLowerCase() == 'text' || style.toLowerCase() == 'text link'
      ">
      &gt;</span
    >
  </Link>
  <a
    v-else-if="
      (tag === 'external' || tag === 'External Link' || tag === 'File') && link
    "
    class="btn"
    :href="link"
    :class="classes">
    <slot>Button Text</slot>
    <span
      v-if="
        style.toLowerCase() == 'text' || style.toLowerCase() == 'text link'
      ">
      &gt;</span
    >
  </a>
  <button
    v-else
    class="btn"
    :class="classes"
    :disabled="disabled"
    @click="onClick">
    <slot>Button Text</slot>
    <component :is="iconComponent" />
    <span
      v-if="
        style.toLowerCase() == 'text' || style.toLowerCase() == 'text link'
      ">
      &gt;</span
    >
  </button>
</template>

<script>
import { Link } from "@inertiajs/vue3";
import { useCustomValidator } from "../../compostables/useValidators";

import NextIcon from "../Svgs/NextArrow.vue";
import BackIcon from "../Svgs/BackArrow.vue";
import RestartIcon from "../Svgs/RestartArrow.vue";
import { computed, useSlots } from "vue";

export default {
  components: {
    Link,
    NextIcon,
    BackIcon,
    RestartIcon,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    link: {
      type: String,
      required: false,
    },
    style: {
      type: String,
      required: false,
      default: "primary",
      validator(value) {
        return useCustomValidator(
          ["primary", "secondary", "text", "text link"],
          value
        );
      },
    },
    tag: {
      type: String,
      required: false,
      default: "button",
      validator(value) {
        return useCustomValidator(
          [
            "button",
            "a",
            "external",
            "internal link",
            "external link",
            "file",
            "none",
          ],
          value
        );
      },
    },
    width: {
      type: String,
      required: false,
      default: "fixed",
      validator(value) {
        return useCustomValidator(["fixed", "flex", "small", "no max"], value);
      },
    },
    icon: {
      type: String,
      required: false,
      validator(value) {
        return useCustomValidator(["next", "back", "restart"], value);
      },
    },
    iconPosition: {
      type: String,
      required: false,
      default: "right",
      validator(value) {
        return useCustomValidator(["right", "left"], value);
      },
    },
  },

  emits: ["btn-click"],

  setup(props, { emit, slots }) {
    const classes = computed(() => ({
      "btn--secondary": props.style.toLowerCase() === "secondary",
      "btn--text":
        props.style.toLowerCase() === "text" ||
        props.style.toLowerCase() === "text link",
      "btn--primary": props.style.toLowerCase() === "primary",
      "btn--icon": props.icon,
      "btn--icon-left": props.iconPosition === "left",
      "btn--flex": props.width === "flex",
      "btn--no-max": props.width === "no max",
      "btn--small": props.width === "small",
    }));

    const iconComponent = computed(() => {
      switch (props.icon) {
        case "next":
          return "NextIcon";
          break;
        case "back":
          return "BackIcon";
          break;
        case "restart":
          return "RestartIcon";
          break;
      }
    });

    const getSlotText = () => {
      const vnodes = slots.default ? slots.default() : [];
      return vnodes
        .map((vnode) =>
          typeof vnode.children === "string" ? vnode.children : ""
        )
        .join("");
    };
    const onClick = () => {
      emit("btn-click", { clicked: true, btnText: getSlotText() });
    };

    return {
      classes,
      iconComponent,
      onClick,
    };
  },
};
</script>
